var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusiness2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.893 44.9473L68.8561 27.1145C67.0849 23.8451 63.5424 21.7646 60 21.7646H40.2214C36.3838 21.7646 33.1365 23.8451 31.3653 27.1145L21.3284 44.9473C19.5572 48.2167 19.5572 52.0804 21.3284 55.0526L31.3653 72.8854C33.1365 76.1547 36.679 78.2352 40.2214 78.2352H60C63.8376 78.2352 67.0849 76.1547 68.8561 72.8854L78.893 55.0526C80.369 52.0804 80.369 47.9194 78.893 44.9473ZM49.9631 61.2941C43.7638 61.2941 38.7454 56.2414 38.7454 49.9999C38.7454 43.7585 43.7638 38.7058 49.9631 38.7058C56.1624 38.7058 61.1808 43.7585 61.1808 49.9999C61.1808 56.2414 56.1624 61.2941 49.9631 61.2941Z",
    fill: "#030D45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.524 43.2L75.1415 19.2C72.7798 14.8 68.0566 12 63.3333 12H36.9619C31.845 12 27.5154 14.8 25.1538 19.2L11.7712 43.2C9.40959 47.6 9.40959 52.8 11.7712 56.8L25.1538 80.8C27.5154 85.2 32.2386 88 36.9619 88H63.3333C68.4502 88 72.7798 85.2 75.1415 80.8L88.524 56.8C90.492 52.8 90.492 47.2 88.524 43.2Z",
    stroke: "#243697",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness2);
export default __webpack_public_path__ + "static/media/Business2.4b11ebb07808825e241b55e9821932e3.svg";
export { ForwardRef as ReactComponent };